import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

HSN.RewardGridControls = function (config) {
    //Touch interaction variables
    var touchStartLocation;
    var swipeDeviation = 50;

    //Grid container name variables
    var gridContainerName = config.gridContainerName;
    var gridCellsContainerName = config.gridCellsContainerName;
    var pageLeftControlName = config.pageLeftControlName;
    var pageRightControlName = config.pageRightControlName;
    var pageNumberControlName = config.pageNumberControlName;
    var deviceInformation = config.deviceInformation;

    //Function variables
    var ChangeGridPage = config.ChangeGridPageFunction;

    $(gridContainerName).on('touchstart', gridCellsContainerName, function (e) {
        touchStartLocation = e.originalEvent.touches[0].pageX;
    });

    $(gridContainerName).on('touchend', gridCellsContainerName, function (e) {
        var currentPage = $(this).data('page');
        var totalPages = $(this).data('totalpages');

        var currentLocation = e.originalEvent.changedTouches[0].pageX;

        if (Math.abs(currentLocation - touchStartLocation) < swipeDeviation) {
            return;
        }
        else if (currentLocation - touchStartLocation >= -1*swipeDeviation && currentPage > 1) {
            ChangeGridPage(currentPage - 1);
        }
        else if (currentLocation - touchStartLocation <= swipeDeviation && currentPage < totalPages) {
            ChangeGridPage(currentPage + 1);
        }
    });

    $(gridContainerName).on('click', pageLeftControlName, function (e) {
        e.stopPropagation();
        e.preventDefault();

        var currentPage = $(this).data('page');
        var newPage = currentPage - 1 > 0 ? currentPage - 1 : 1;

        ChangeGridPage(newPage);
    });

    $(gridContainerName).on('click', pageRightControlName, function (e) {
        e.stopPropagation();
        e.preventDefault();

        var currentPage = $(this).data('page');
        var newPage = currentPage + 1;

        ChangeGridPage(newPage);
    });

    $(gridContainerName).on('keyup', pageNumberControlName, function (e) {
        e.stopPropagation();
        e.preventDefault();

        var newPage = $(this).val();
        var totalPages = $(this).data('totalpages');

        if (e.keyCode === 13) {
            if (newPage > 0 && newPage <= totalPages) {
                ChangeGridPage(newPage);
            }
            else {
                alert(newPage + ' is not a valid page number.');
            }
        }

        return;
    });

    $(gridContainerName).on('keydown', pageNumberControlName, function (e) {
        if (deviceInformation.IsAndroidPhone || deviceInformation.IsAndroidTablet) {
            var newPage = $(this).val();
            var totalPages = $(this).data('totalpages');

            if (e.which === 9) {
                if (newPage > 0 && newPage <= totalPages) {
                    ChangeGridPage(newPage);
                }
                else {
                    alert(newPage + ' is not a valid page number.');
                }
            }
        }
          
        return;
    });

    $(gridContainerName).on('mouseup', pageNumberControlName, function (e) {
        e.stopPropagation();
        e.preventDefault();

        $(this).select();
    });
};

HSN.RewardEntryModal = (function (parent) {
    __extends(RewardEntryModal, parent);

    function RewardEntryModal(config) {
        var modal = RewardEntryModal.__super__.constructor.call(this, "reward-entry");

        this.callbackok = null;
        this.callbackcancel = null;
        this.name = 'HSN.RewardEntryModal';

        this.Close.off();//remove existing handler, have our own

        eventHandlers(this);

        var loader = $('<div id="loader" class="loader"><img alt="" src="/assets/img/spinner-l-d8d9d9.gif"></div>');
        loader.appendTo(this.Root);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function () {
            closeModal(modal);
        });
    }

    function closeModal(modal) {
        $('.video-flash').css('visibility', 'visible');

        modal.Hide();
        $('#modal-mask').remove();

        if (modal.hideCallback) {
            modal.hideCallback();
        }
    }

    RewardEntryModal.prototype.hideCallback = null;

    RewardEntryModal.prototype.SetHideCallback = function (hideCallback) {
        this.hideCallback = hideCallback;
    };

    /**
    * HSN.RewardEntryModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    RewardEntryModal.prototype.SetOkCallback = function (callbackOk) {
        this.callbackok = callbackOk;
    };
    RewardEntryModal.prototype.SetCancelCallback = function (callbackCancel) {
        this.callbackcancel = callbackCancel;
    };
    RewardEntryModal.prototype._show = function (rewardId, url) {
        $('.video-flash').css('visibility', 'hidden');

        $.ajax(url + rewardId,
        {
                cache: false,
                context: this,
                dataType: 'html',
                success: function (data, status, xhr) {
                    var __scope = this;

                    __scope.Root.removeClass('loading');

                    this.Content.showHtml (
                        data,
                        0,
                        function () {
                            __scope.Center();
                            __scope.Content.animate({ opacity: 1 });
                            //handle any tooltips loaded
                            if (!Modernizr.touchevents) {
                                HSN.Tooltip(__scope.Content.find("[data-tooltip]"));
                            }
                        },
                        function () {
                            //__scope.Center();
                        }
                    );
                },
                error: function (xhr, status, error) {
                    alert("Unfortunately there was an error attempting to load the content, please try again.");
                    $('#modal-mask').remove();
                }
            }
        );
    };
    RewardEntryModal.prototype.ChangeContent = function (html) {
        var __scope = this;
        this.Content.showHtml(
            html,
            0,
            function () {
                __scope.Center();
                __scope.Content.animate({ opacity: 1 });
                //handle any tooltips loaded
                if (!Modernizr.touchevents) {
                    HSN.Tooltip(__scope.Content.find("[data-tooltip]"));
                }
            },
            function () {
                //__scope.Center();
            }
        );
    };

    return RewardEntryModal;
})(HSN.Modal);

HSN.RewardEntryControls = function (config) {
    var application = config.application;
    var containerName = config.containerName;
    var possibleEntries = config.possibleEntries;
    var rewardId = config.rewardId;
    var deviceInformation = application.DeviceInformation;

    if(possibleEntries > 0) {
        buildEntryDropDown(".entry-selection", possibleEntries);
    }

    $(containerName).on('click', '.enter-more-button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        window.location.href = '/rewards';
    });

    $(containerName).on('click', '.earn-more-button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        window.location.href = '/arcade';
    });

    $(containerName).on('click', '.play-on-button', function(e) {
        e.stopPropagation();
        e.preventDefault();
        window.location.href = '/arcade';
    });

    $(containerName).on('click', '.entry-submit-button', function(e) {
        e.stopPropagation();
        e.preventDefault();

        var entrySelection = $('.entry-selection').find('option:selected').val();

        if (parseInt(entrySelection) === 0) {
            $('.entry-submit-error').removeClass('error-off');
            $('.entry-submit-error').addClass('error-on');

            return false;
        }

        cmCreateManualLinkClickTag('/rewards?cm_sp=ArcadeSweeps-_-EnterSweeps-_-Submit&cm_re=ArcadeSweeps-_-EnterSweeps-_-Submit', 'ArcadeSweepsSubmit');

        var data = {};

        data.optin = $('#EmailOptIn').length > 0 ? $('#EmailOptIn').is(":checked") : false;
        data.rewardId = rewardId;
        data.quantity = entrySelection;

        $.ajax({
            type : "POST",
            url : "/rewards/submit/sweepstakes",
            data: data,
            dataType: "json",
            success: function (result) {
                if(deviceInformation.IsMobile) {
                    var url = "/rewards/submit/confirmation?";
                    url += jQuery.param(result);
                    window.location.href = url;
                }
                else {
                    $.ajax({
                        type: "GET",
                        url: "/rewards/submit/sweepstakes",
                        data: result,
                        dataType: "html",
                        success: function (html) {
                            HSN.Instance().GetRewardEntryModal().ChangeContent(html);
                        }
                    });
                }              
            }
        });
    });

    $(containerName).on('click', '.cancel-button', function(e) {
        e.stopPropagation();
        e.preventDefault();

        window.location.href = "/rewards";
    });

       

    $(containerName).on('click', '.create-nickname-button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        if(deviceInformation.IsMobile) {
            var nicknameUrl = $(this).data('nicknameUrl');
            window.location.href = nicknameUrl;
        }
        else {
            var rewardId = $(this).data('rewardid');

            $('.modal.reward-entry #closeModal').click();

            HSN.Instance().Events.On(HSN.Application.EVENT.NICKNAME_ADDED, function () {
                HSN.Instance().GetRewardEntryModal().Show(rewardId, '/rewards/showentry/sweepstakes/');
            }, this);

            HSN.Instance().GetNicknameModal().Show();
        }            
    });

    $(containerName).on("change", '.entry-selection', function (e) {
        e.stopPropagation();
        e.preventDefault();

        var ticketCost = $(this).data('ticket-cost');
        var entrySelection = $(this).find('option:selected').val();

        if (entrySelection > 0) {
            $('.entry-submit-error').removeClass('error-on');
            $('.entry-submit-error').addClass('error-off');
        }
        else {
            $('.entry-submit-error').removeClass('error-off');
            $('.entry-submit-error').addClass('error-on');
        }

        $('.redeemed-ticket-amount').html(parseInt(entrySelection * ticketCost).toLocaleString());
    });

    function buildEntryDropDown(id, entries) {
        if($(id).length > 0) {
            var dropdown = $(id)[0];

            var optionLabel = document.createElement("OPTION");
            optionLabel.text = 'Select';
            optionLabel.value = '0';
            dropdown.options.add(optionLabel);

            for(var i = entries; i >= 1; i--) {
                var option = document.createElement("OPTION");
                if(i === 1)
                    option.text = i.toString() + ' Entry';
                else
                    option.text = i.toString() + ' Entries';
                option.value = i.toString();
                dropdown.options.add(option);
            }
        }
    }
}



HSN.CodeCollectorModal = (function (parent) {
    __extends(CodeCollectorModal, parent);

    function CodeCollectorModal(config) {
        var modal = CodeCollectorModal.__super__.constructor.call(this, "code-collector-entry");

        this.callbackok = null;
        this.callbackcancel = null;
        this.name = 'HSN.CodeCollectorModal';

        this.Close.off();//remove existing handler, have our own

        eventHandlers(this);

        var loader = $('<div id="loader" class="loader"><img alt="" src="/assets/img/spinner-l-d8d9d9.gif"></div>');
        loader.appendTo(this.Root);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function () {
            closeModal(modal);
        });
    }

    function closeModal(modal) {
        $('.video-flash').css('visibility', 'visible');

        modal.Hide();
        $('#modal-mask').remove();

        if (modal.hideCallback) {
            modal.hideCallback();
        }
    }

    CodeCollectorModal.prototype.hideCallback = null;

    CodeCollectorModal.prototype.SetHideCallback = function (hideCallback) {
        this.hideCallback = hideCallback;
    };

    /**
    * HSN.CodeCollectorModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    CodeCollectorModal.prototype.SetOkCallback = function (callbackOk) {
        this.callbackok = callbackOk;
    };
    CodeCollectorModal.prototype.SetCancelCallback = function (callbackCancel) {
        this.callbackcancel = callbackCancel;
    };
    CodeCollectorModal.prototype._show = function () {
        $('.video-flash').css('visibility', 'hidden');

        $.ajax('/codecollector/showentry',
        {
            cache: false,
            context: this,
            dataType: 'html',
            success: function (data, status, xhr) {
                var __scope = this;

                __scope.Root.removeClass('loading');

                this.Content.showHtml(
                    data,
                    0,
                    function () {
                        __scope.Center();
                        __scope.Content.animate({ opacity: 1 });
                        //handle any tooltips loaded
                        if (!Modernizr.touchevents) {
                            HSN.Tooltip(__scope.Content.find("[data-tooltip]"));
                        }
                    },
                    function () {
                        //__scope.Center();
                    }
                );
            },
            error: function (xhr, status, error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        }
        );
    };
    CodeCollectorModal.prototype.ChangeContent = function (html) {
        var __scope = this;
        this.Content.showHtml(
            html,
            0,
            function () {
                __scope.Center();
                __scope.Content.animate({ opacity: 1 });
                //handle any tooltips loaded
                if (!Modernizr.touchevents) {
                    HSN.Tooltip(__scope.Content.find("[data-tooltip]"));
                }
            },
            function () {
                //__scope.Center();
            }
        );
    };

    return CodeCollectorModal;
})(HSN.Modal);

HSN.CodeCollectorControls = function (config) {
    var containerName = config.containerName;
    var isNativeSignInCapable = config.isNativeSignInCapable;

    $(containerName).on('click', '.entry-submit-button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        var code = $(containerName).find('#code').val().trim();
        $('.error-off').hide();
        if (code !== "") {
            $.ajax({
                type : "POST",
                url: "/codecollector/submit",
                data : { code : code },
                success: function (data, status, xhr) {
                    var ct = xhr.getResponseHeader("content-type") || "";
                    if (ct.indexOf('html') > -1) {
                        cmCreateElementTag("Finish", "Code Collector");
                        HSN.DataLayer.helpers.elementInteraction(null, "Code Collector", "Finish");
                        HSN.Instance().GetCodeCollectorEntryModal().ChangeContent(data);
                    }
                    if (ct.indexOf('json') > -1) {
                        if (data.isError) {
                            cmCreateElementTag("Invalid or Expired Entry", "Code Collector");
                            HSN.DataLayer.helpers.elementInteraction(null, "Code Collector", "Invalid or Expired Entry");
                            $(containerName).find('.entry-submit-error').show();
                        }
                        if (data.isAlreadyEntered) {
                            cmCreateElementTag("Already Used", "Code Collector");
                            HSN.DataLayer.helpers.elementInteraction(null, "Code Collector", "Already Used");
                            $(containerName).find('.entry-already-submitted-error').show();
                        }
                    }
                }
            });
        }
        else {
            $(containerName).find('.entry-empty-error').show();
        }
    });

    $(containerName).on('click', '.sign-in-button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        $('.modal.code-collector-entry #closeModal').click();

        HSN.Instance().Events.On(HSN.Application.EVENT.VISITOR_AUTHENTICATED, function () {
            cmCreateManualLinkClickTag('/rewards?cm_sp=ArcadeSweeps-_-EnterSweeps-_-Submit&cm_re=ArcadeSweeps-_-EnterSweeps-_-Submit', 'ArcadeSweepsSubmit');
            HSN.Instance().GetCodeCollectorEntryModal().Show();
        }, this);

        if (HSN.Instance().DeviceInformation.IsNativeApp && isNativeSignInCapable) {
            var jsonData = { "returnUrl": window.location.href };
            var command = 'hsn://HSNWebView.Signin/false/MoreInfo/' + encodeURIComponent(JSON.stringify(jsonData));
            gap.ExecCommand(command);
        }
        else {
            window.location = "/signin?isCommunity=true";
        }
    });

    $(containerName).on('click', '.create-nickname-button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        $('.modal.code-collector-entry #closeModal').click();

        HSN.Instance().Events.On(HSN.Application.EVENT.NICKNAME_ADDED, function () {
            cmCreateManualLinkClickTag('/rewards?cm_sp=ArcadeSweeps-_-EnterSweeps-_-Submit&cm_re=ArcadeSweeps-_-EnterSweeps-_-Submit', 'ArcadeSweepsSubmit');
            HSN.Instance().GetCodeCollectorEntryModal().Show();
        }, this);

        HSN.Instance().GetNicknameModal().Show();
    });

    $(containerName).on("click", ".rules-link", function () {
        HSN.Instance().GetPageIdModal().Show("#code-collector-rules");
        return false;
    });

    $(containerName).on("click", ".whats-this", function () {
        HSN.Instance().GetHsnCaresDisclaimerModal().Show($(this).data('desc'));
        return false;
    });
}



// WEBPACK FOOTER //
// ./assets/js/HSN/Rewards/Rewards.js